<svg:g #ticksel>
  @for (tick of ticks; track tick) {
    <svg:g class="tick" [attr.transform]="tickTransform(tick)">
      <title>{{ tickFormat(tick) }}</title>
      <svg:text
        stroke-width="0.01"
        [attr.text-anchor]="textAnchor"
        [attr.transform]="textTransform"
        [style.font-size.px]="12"
        >
        {{ tickTrim(tickFormat(tick)) }}
        </svg:text>
        </svg:g>
      }
      </svg:g>

      @for (tick of ticks; track tick) {
        <svg:g [attr.transform]="tickTransform(tick)">
          @if (showGridLines) {
            <svg:g [attr.transform]="gridLineTransform()">
              <svg:line class="gridline-path gridline-path-vertical" [attr.y1]="-gridLineHeight" y2="0" />
              </svg:g>
            }
            </svg:g>
          }

          <svg:g #referenceLinesEl>
            @if (showRefLines) {
              <ng-container>
                @for (refLine of referenceLines; track refLine) {
                  <svg:g>
                    <svg:g [attr.transform]="refLineTransform(refLine.value)">
                      <svg:line class="refline-path gridline-path-horizontal" y1="0" [attr.y2]="gridLineHeight" />
                      @if (showRefLabels) {
                        <svg:g>
                          <title>{{ tickTrim(tickFormat(refLine.value)) }}</title>
                          <svg:text class="refline-label" dy="0.71em" x="6" y="0" text-anchor="start">
                            {{ refLine.name }}
                            </svg:text>
                            </svg:g>
                          }
                          </svg:g>
                          </svg:g>
                        }
                      </ng-container>
                    }
                    </svg:g>
